<template>
  <div class="flex flex-col w-full overflow-hidden">
    <div class="w-full h-full flex-grow overflow-y-auto" @scroll="handleScroll">
      <div class="w-full max-w-content mx-auto">
        <div class="h-10" ref="spacer"></div>
        <base-back-button />
        <div class="px-4 sm:px-0">
          <h2 class="font-sans text-2xl uppercase mb-1" ref="pageTitle">{{ pageTitle }}</h2>
          <h3 class="text-neutral mb-2">Acceso a las instalaciones mediante reconocimiento facial</h3>
          <base-message-box>
            <template slot="content">
              <p>Los menores de 3 años no pueden utilizar la tecnología de acceso biométrico.</p>
            </template>
          </base-message-box>
        </div>
        <div class="h-10"></div>
        <div class="px-4 sm:px-0"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { handleScrollMixin } from '@/mixins/appMixin'

export default {
  name: 'BiometricInfant',
  mixins: [handleScrollMixin],
  data: function () {
    return {
      loading: false,
      pageTitle: 'Estado de acceso biométrico'
    }
  }
}
</script>

<style lang="scss" scoped></style>
